import AppHttpClient from "../core/http/index";

export interface ResultPdfStatusResponse {
  excel_name: string;
  pdf_name: string;
  status: string;
  ready: boolean;
  progress?: { done: number; total: number } | null;
  error?: string | null;
}

export const getResultPdfStatus = (excel_name: string) =>
  AppHttpClient.get<ResultPdfStatusResponse>(
    `/result_pdf_status?excel_name=${encodeURIComponent(excel_name)}`,
    {}
  );

export const downloadResultPdf = (excel_name: string) =>
  AppHttpClient.post(
    `/download_pdf?excel_name=${encodeURIComponent(excel_name)}`,
    {}
  );
